module.exports = __webpack_public_path__ + "static/media/rawlings scriptorium.37099313.jpeg";